import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useState, useEffect } from 'react';
import { Container, Box, AppBar, Toolbar, Typography } from '@mui/material';
import { LanguageContext } from '../contexts/LanguageContext';
import LaunchScreen from './LaunchScreen';
import FindQuietPlace from './FindQuietPlace';
import BreathingExercise from './BreathingExercise';
import Grounding from './Grounding';
import MuscleRelaxation from './MuscleRelaxation';
import LanguageSelector from './LanguageSelector';
// Define app screens
export var Screen;
(function (Screen) {
    Screen["LAUNCH"] = "launch";
    Screen["FIND_QUIET_PLACE"] = "find-quiet-place";
    Screen["BREATHING"] = "breathing";
    Screen["GROUNDING"] = "grounding";
    Screen["MUSCLE_RELAXATION"] = "muscle-relaxation";
})(Screen || (Screen = {}));
var App = function () {
    var _a = useContext(LanguageContext), t = _a.t, isFirstRun = _a.isFirstRun, setIsFirstRun = _a.setIsFirstRun;
    var _b = useState(isFirstRun ? Screen.LAUNCH : Screen.FIND_QUIET_PLACE), currentScreen = _b[0], setCurrentScreen = _b[1];
    // Check if it's first run for install banner logic
    useEffect(function () {
        // Trigger install banner for first run
        if (isFirstRun) {
            localStorage.setItem('showInstallBanner', 'true');
        }
    }, [isFirstRun]);
    // Update current screen when isFirstRun changes
    useEffect(function () {
        if (!isFirstRun && currentScreen === Screen.LAUNCH) {
            setCurrentScreen(Screen.FIND_QUIET_PLACE);
        }
    }, [isFirstRun, currentScreen]);
    // Render current screen
    var renderScreen = function () {
        switch (currentScreen) {
            case Screen.LAUNCH:
                return _jsx(LaunchScreen, { onProceed: function () { return setCurrentScreen(Screen.FIND_QUIET_PLACE); } });
            case Screen.FIND_QUIET_PLACE:
                return _jsx(FindQuietPlace, { onProceed: function () { return setCurrentScreen(Screen.BREATHING); } });
            case Screen.BREATHING:
                return _jsx(BreathingExercise, { onProceed: function () { return setCurrentScreen(Screen.GROUNDING); } });
            case Screen.GROUNDING:
                return _jsx(Grounding, { onProceed: function () { return setCurrentScreen(Screen.MUSCLE_RELAXATION); } });
            case Screen.MUSCLE_RELAXATION:
                return _jsx(MuscleRelaxation, { onFinish: function () { return setCurrentScreen(Screen.FIND_QUIET_PLACE); } });
            default:
                return _jsx(FindQuietPlace, { onProceed: function () { return setCurrentScreen(Screen.BREATHING); } });
        }
    };
    return (_jsxs(Box, { sx: {
            flexGrow: 1,
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        }, children: [_jsx(AppBar, { position: "static", children: _jsxs(Toolbar, { children: [_jsx(Typography, { variant: "h6", component: "div", sx: { flexGrow: 1 }, children: t('appTitle') }), _jsx(LanguageSelector, {})] }) }), _jsx(Container, { component: "main", sx: {
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    p: 0,
                    maxWidth: '100%'
                }, children: renderScreen() })] }));
};
export default App;
